import { BaseComponent } from "../BaseComponent";
import { ComponentNames } from 'src/app/helper/componentNames';


export class OverheadStorageComponent extends BaseComponent{
    constructor(){
        super();
        this.componentType = ComponentNames.overheadStorageComponent;
    }
}